/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { IArtByCustomerIdPayload, IArtEntity, IArtsByCustomerListRepsonse, IArtsListResponse, ICreateArtPayload, IUpdateArtPayload } from "./arts.interface";
import { Environment } from "../../../Config/constants";

export class ArtsApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public destroy = async (boxId: string): Promise<Result<void>> => {
    try {
        const response = await this.service.delete(`/approved-arts/${boxId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public create = async (data: ICreateArtPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.post(`/approved-arts`, data );

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public list = async (page: number): Promise<Result<IArtsListResponse>> => {
    try {
        const response = await this.service.get(`/approved-arts`, { params: { 
          page, 
          offset: Number(Environment.OFFSET_REGISTERS),
         }});

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public listByCustomer = async ({ customerId, page, searchBy, productId }: IArtByCustomerIdPayload): Promise<Result<IArtsByCustomerListRepsonse>> => {
    try {
      const response = await this.service.get(`/approved-arts/customer/${customerId}`, { params: { page,  offset: Number(Environment.OFFSET_REGISTERS), searchBy, productId }});

      return Result.ok(response.data);
    } catch (error) {
      return Result.fail(error?.response?.data ?? error);
    }
  }

  public show = async (boxId: string): Promise<Result<IArtEntity | undefined>> => {
    try {
        const response = await this.service.get(`/approved-arts/${boxId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public update = async (data: IUpdateArtPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.put(`/approved-arts/${data.id}`, data );

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };
}
